/**
 * Count how many DISTINCT non-empty device fingerprints in the recent
 * sign-in history are NOT in the user's trusted-devices whitelist.
 *
 * Used by the Daybreak morning-ritual chip to nudge the operator toward
 * the Settings → Recent sign-ins panel once a day when something fresh
 * has slipped through unreviewed.
 *
 * @param {Array<{fingerprint?: string}>} history  signinHistory from /auth/me
 * @param {string[]} trustedDevices  user.trustedDevices
 * @returns {number} count of distinct unrecognised fingerprints
 */
export function countUnrecognisedDevices(history, trustedDevices) {
  if (!Array.isArray(history) || history.length === 0) return 0;
  const trusted = new Set(trustedDevices || []);
  const seen = new Set();
  for (const entry of history) {
    const fp = entry?.fingerprint;
    if (!fp) continue;
    if (trusted.has(fp)) continue;
    seen.add(fp);
  }
  return seen.size;
}
